/**
 * Responsive WebP sources for the static activity tiles (website audit,
 * 13 Oct 2026, item 4). The JPEGs in public/activity are shipped as-is at
 * 1080–2176 px (run.jpg alone was 1.5 MB) and drawn 140–300 px wide. The
 * matching `<base>-480.webp`, `-768.webp`, `-1280.webp` and `<base>.webp`
 * files sit next to them (generated once with sharp, quality 78/80; see the
 * commit that added them). The JPEG stays as the <img> fallback.
 *
 * Only the widths that exist per file are listed: sources narrower than a
 * step were not upscaled.
 */
const WIDTHS: Record<string, { steps: number[]; full: number }> = {
  all: { steps: [480, 768], full: 1080 },
  "court-editorial": { steps: [480, 768, 1280], full: 1600 },
  lounge: { steps: [480, 768], full: 1080 },
  "new-in": { steps: [480, 768], full: 1080 },
  run: { steps: [480, 768, 1280], full: 1600 },
  "studio-editorial": { steps: [480, 768, 1280], full: 1600 },
  tennis: { steps: [480, 768], full: 1080 },
  train: { steps: [480, 768], full: 1080 },
  yoga: { steps: [480, 768], full: 1080 },
};

/**
 * `/activity/run.jpg?v=1` → `/activity/run-480.webp?v=1 480w, …, /activity/run.webp 1600w`.
 * Returns null for anything that is not a known activity JPEG (CDN product
 * images, partner tiles) so callers fall back to a plain <img>.
 */
export function activityWebpSrcSet(src: string | null | undefined): string | null {
  if (!src) return null;
  const m = src.match(/^\/activity\/([a-z0-9-]+)\.jpe?g(\?.*)?$/i);
  if (!m) return null;
  const spec = WIDTHS[m[1].toLowerCase()];
  if (!spec) return null;
  const q = m[2] || "";
  const parts = spec.steps.map((w) => `/activity/${m[1]}-${w}.webp${q} ${w}w`);
  parts.push(`/activity/${m[1]}.webp${q} ${spec.full}w`);
  return parts.join(", ");
}
